import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import {
  // Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import TablePagination from '../../components/molecules/TablePagination';
// import CommonButton from '../../components/atoms/CommonButton';
import CommonButtonId from '../../components/atoms/CommonButtonId';

const styles = {
  root: {
    marginTop: 15
  },
  overflow: {
    overflow: 'auto'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  textRed: {
    color: '#F50057'
  },
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      budgets: state.groupBudgets.budgets,
      totalCount: state.groupBudgets.totalCount,
      offset: 1
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withHandlers({
    handleChangeRowsPerPage: props => event => {
      props.setRowsPerPage(parseInt(event.target.value, 10));
      props.handleChangePage(event, 1, parseInt(event.target.value, 10));
      // props.setRowsPerPage(event.target.value);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    budgets,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    offset,
    onChangeBudgetStatus,
    onSendBudgetEmail,
    // checkedBudgetIds,
    // setCheckedBudgetIds,
    // checkedSystemIds,
    // setCheckedSystemIds,
    handleChangeRowsPerPage,
    selectedPage,
    // loginToShashoku,
    // openShashokuAddModal,
    onEditBudget
    // checkState
    // setCheckState,
    // uncheckAll
  }) => {
    // function checkAll() {
    //   setCheckState(true);
    //   const newCheckedBudgetIds = new Set(checkedBudgetIds);
    //   const newCheckedSystemIds = new Set(checkedSystemIds);
    //   budgets.forEach(el => {
    //     if (el.confirmFlag === 0 && el.shashokuBudgetId !== null)
    //       newCheckedBudgetIds.add(el.shashokuBudgetId);
    //     newCheckedSystemIds.add(el.connectSystemId);
    //   });
    //   setCheckedBudgetIds(newCheckedBudgetIds);
    //   setCheckedSystemIds(newCheckedSystemIds);
    // }

    // function handleChangeChecked(budgetId, systemId, isChecked) {
    //   const newCheckedBudgetIds = new Set(checkedBudgetIds);
    //   const newCheckedSystemIds = new Set(checkedSystemIds);
    //   if (isChecked) {
    //     if (budgetId) newCheckedBudgetIds.add(budgetId);
    //     newCheckedSystemIds.add(systemId);
    //   } else {
    //     if (budgetId) newCheckedBudgetIds.delete(budgetId);
    //     newCheckedSystemIds.delete(systemId);
    //   }
    //   setCheckedBudgetIds(newCheckedBudgetIds);
    //   setCheckedSystemIds(newCheckedSystemIds);
    // }

    // function onClickChangeMultiStatus() {
    //   onChangeBudgetStatus(Array.from(checkedBudgetIds));
    // }

    // function onClickSendMultiEmail() {
    //   onSendBudgetEmail(Array.from(checkedSystemIds));
    // }

    const onClickChangeStatus = id => {
      const ids = [];
      ids.push(id);
      onChangeBudgetStatus(ids);
    };

    const onClickSendBudgetEmail = id => {
      const ids = [];
      ids.push(id);
      onSendBudgetEmail(ids);
    };

    return (
      <div className={classes.root}>
        <div className={classes.buttonContainer}>
          {/* <CommonButton
            className={classes.button}
            title="Add Bizmeshi"
            onClickAction={openShashokuAddModal}
          /> */}
          {/* <CommonButton
            className={classes.button}
            title={checkState ? '全て選択解除' : '全て選択'}
            onClickAction={checkState ? uncheckAll : checkAll}
          />
          <CommonButton
            className={classes.button}
            title="一括更新 (送信)"
            onClickAction={onClickChangeMultiStatus}
          />
          <CommonButton
            className={classes.button}
            title="一括メール送信"
            onClickAction={onClickSendMultiEmail}
          /> */}
        </div>
        <div className={classes.scrollTable}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {/* <TableCell /> */}
                <TableCell>グループID</TableCell>
                <TableCell>グループ名</TableCell>
                <TableCell>住所</TableCell>
                <TableCell />
                <TableCell>予算</TableCell>
                <TableCell />
                <TableCell>入金確認日</TableCell>
                <TableCell>更新状況</TableCell>
                <TableCell>更新日時</TableCell>
                <TableCell />
                <TableCell />
                {/* <TableCell /> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {budgets &&
                budgets.map(budget => (
                  <TableRow>
                    {/* <TableCell>
                      {
                        <Checkbox
                          color="primary"
                          checked={checkedSystemIds.has(budget.connectSystemId)}
                          onChange={e =>
                            handleChangeChecked(
                              budget.shashokuBudgetId,
                              budget.connectSystemId,
                              e.target.checked
                            )
                          }
                        />
                      }
                    </TableCell> */}
                    <TableCell>{budget.groupId}</TableCell>
                    <TableCell>{budget.groupName}</TableCell>
                    <TableCell>{budget.groupAddress}</TableCell>
                    <TableCell>
                      {budget.budgetAmount &&
                      budget.requestAmount > 0 &&
                      budget.requestStatus !== 1
                        ? `変更前\n¥${budget.budgetAmount.toLocaleString()}`
                        : ''}
                    </TableCell>
                    <TableCell>
                      {budget.requestAmount > 0 && budget.requestStatus !== 1
                        ? `¥${(
                            budget.budgetAmount + budget.requestAmount
                          ).toLocaleString()}`
                        : `¥${budget.budgetAmount.toLocaleString()}`}
                      {/* <span className={classes.textRed}>予算未設定</span> */}
                    </TableCell>
                    <TableCell>
                      <CommonButtonId
                        className={classes.button}
                        title="編集"
                        onClickAction={() => onEditBudget(budget)}
                        disabled={budget.requestStatus === 0}
                      />
                    </TableCell>
                    <TableCell>{budget.confirmedAt}</TableCell>
                    {budget.requestStatus === 0 && (
                      <TableCell>未入金</TableCell>
                    )}
                    {budget.requestStatus === null && (
                      <TableCell>入金済</TableCell>
                    )}
                    <TableCell>{budget.updatedAt}</TableCell>
                    <TableCell>
                      <CommonButtonId
                        id={budget.budgetRequestId}
                        className={classes.button}
                        title="入金OK"
                        disabled={budget.requestStatus !== 0}
                        onClickAction={() =>
                          onClickChangeStatus(budget.budgetRequestId)
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <CommonButtonId
                        className={classes.button}
                        title="入金NG"
                        disabled={
                          budget.requestStatus !== 0 &&
                          budget.budgetRequestType !== 1
                        }
                        onClickAction={() =>
                          onClickSendBudgetEmail(budget.budgetRequestId)
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>

        <TablePagination
          searchResults={budgets}
          rowsPerPage={rowsPerPage}
          page={page - 1}
          handleChangePage={(e, p) => handleChangePage(e, p + 1)}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          totalCount={totalCount}
          offset={offset}
          selectedPage={selectedPage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
